import type { ThemeItem } from '../../../core/domain'

const EUROPEAN_CITIES = [
  ['Paris', 'France'],
  ['Lyon', 'France'],
  ['Marseille', 'France'],
  ['Nice', 'France'],
  ['Bordeaux', 'France'],
  ['Toulouse', 'France'],
  ['Strasbourg', 'France'],
  ['Lille', 'France'],
  ['Nantes', 'France'],
  ['Avignon', 'France'],
  ['London', 'United Kingdom'],
  ['Edinburgh', 'United Kingdom'],
  ['Glasgow', 'United Kingdom'],
  ['Manchester', 'United Kingdom'],
  ['Liverpool', 'United Kingdom'],
  ['Bath', 'United Kingdom'],
  ['Oxford', 'United Kingdom'],
  ['Cambridge', 'United Kingdom'],
  ['York', 'United Kingdom'],
  ['Belfast', 'United Kingdom'],
  ['Rome', 'Italy'],
  ['Florence', 'Italy'],
  ['Venice', 'Italy'],
  ['Milan', 'Italy'],
  ['Naples', 'Italy'],
  ['Bologna', 'Italy'],
  ['Verona', 'Italy'],
  ['Turin', 'Italy'],
  ['Palermo', 'Italy'],
  ['Siena', 'Italy'],
  ['Madrid', 'Spain'],
  ['Barcelona', 'Spain'],
  ['Seville', 'Spain'],
  ['Granada', 'Spain'],
  ['Valencia', 'Spain'],
  ['Bilbao', 'Spain'],
  ['Santiago de Compostela', 'Spain'],
  ['Toledo', 'Spain'],
  ['Malaga', 'Spain'],
  ['Cordoba', 'Spain'],
  ['Lisbon', 'Portugal'],
  ['Porto', 'Portugal'],
  ['Sintra', 'Portugal'],
  ['Coimbra', 'Portugal'],
  ['Braga', 'Portugal'],
  ['Faro', 'Portugal'],
  ['Berlin', 'Germany'],
  ['Munich', 'Germany'],
  ['Hamburg', 'Germany'],
  ['Cologne', 'Germany'],
  ['Dresden', 'Germany'],
  ['Heidelberg', 'Germany'],
  ['Nuremberg', 'Germany'],
  ['Leipzig', 'Germany'],
  ['Frankfurt', 'Germany'],
  ['Rothenburg ob der Tauber', 'Germany'],
  ['Amsterdam', 'Netherlands'],
  ['Rotterdam', 'Netherlands'],
  ['Utrecht', 'Netherlands'],
  ['The Hague', 'Netherlands'],
  ['Maastricht', 'Netherlands'],
  ['Brussels', 'Belgium'],
  ['Bruges', 'Belgium'],
  ['Ghent', 'Belgium'],
  ['Copenhagen', 'Denmark'],
  ['Aarhus', 'Denmark'],
  ['Stockholm', 'Sweden'],
  ['Gothenburg', 'Sweden'],
  ['Malmo', 'Sweden'],
  ['Oslo', 'Norway'],
  ['Bergen', 'Norway'],
  ['Tromso', 'Norway'],
  ['Helsinki', 'Finland'],
  ['Turku', 'Finland'],
  ['Reykjavik', 'Iceland'],
  ['Akureyri', 'Iceland'],
  ['Vienna', 'Austria'],
  ['Salzburg', 'Austria'],
  ['Prague', 'Czechia'],
  ['Cesky Krumlov', 'Czechia'],
  ['Budapest', 'Hungary'],
  ['Krakow', 'Poland'],
  ['Warsaw', 'Poland'],
  ['Gdansk', 'Poland'],
  ['Wroclaw', 'Poland'],
  ['Ljubljana', 'Slovenia'],
  ['Zagreb', 'Croatia'],
  ['Dubrovnik', 'Croatia'],
  ['Split', 'Croatia'],
  ['Sarajevo', 'Bosnia and Herzegovina'],
  ['Athens', 'Greece'],
  ['Thessaloniki', 'Greece'],
  ['Nafplio', 'Greece'],
  ['Bucharest', 'Romania'],
  ['Brasov', 'Romania'],
  ['Sofia', 'Bulgaria'],
  ['Plovdiv', 'Bulgaria'],
  ['Belgrade', 'Serbia'],
  ['Tallinn', 'Estonia'],
  ['Riga', 'Latvia']
] as const

const ASIAN_CITIES = [
  ['Tokyo', 'Japan'],
  ['Kyoto', 'Japan'],
  ['Osaka', 'Japan'],
  ['Nara', 'Japan'],
  ['Hiroshima', 'Japan'],
  ['Kanazawa', 'Japan'],
  ['Sapporo', 'Japan'],
  ['Hakodate', 'Japan'],
  ['Fukuoka', 'Japan'],
  ['Nagasaki', 'Japan'],
  ['Kobe', 'Japan'],
  ['Takayama', 'Japan'],
  ['Kamakura', 'Japan'],
  ['Nikko', 'Japan'],
  ['Naha', 'Japan'],
  ['Beijing', 'China'],
  ['Shanghai', 'China'],
  ["Xi'an", 'China'],
  ['Chengdu', 'China'],
  ['Guangzhou', 'China'],
  ['Shenzhen', 'China'],
  ['Hangzhou', 'China'],
  ['Suzhou', 'China'],
  ['Nanjing', 'China'],
  ['Guilin', 'China'],
  ['Kunming', 'China'],
  ['Lijiang', 'China'],
  ['Harbin', 'China'],
  ['Qingdao', 'China'],
  ['Chongqing', 'China'],
  ['Hong Kong', 'Hong Kong'],
  ['Macau', 'Macau'],
  ['Taipei', 'Taiwan'],
  ['Tainan', 'Taiwan'],
  ['Kaohsiung', 'Taiwan'],
  ['Seoul', 'South Korea'],
  ['Busan', 'South Korea'],
  ['Gyeongju', 'South Korea'],
  ['Jeonju', 'South Korea'],
  ['Incheon', 'South Korea'],
  ['Daegu', 'South Korea'],
  ['Jeju City', 'South Korea'],
  ['Suwon', 'South Korea'],
  ['Delhi', 'India'],
  ['Mumbai', 'India'],
  ['Jaipur', 'India'],
  ['Agra', 'India'],
  ['Varanasi', 'India'],
  ['Udaipur', 'India'],
  ['Jodhpur', 'India'],
  ['Kolkata', 'India'],
  ['Chennai', 'India'],
  ['Bengaluru', 'India'],
  ['Hyderabad', 'India'],
  ['Kochi', 'India'],
  ['Mysuru', 'India'],
  ['Amritsar', 'India'],
  ['Rishikesh', 'India'],
  ['Ahmedabad', 'India'],
  ['Pune', 'India'],
  ['Panaji', 'India'],
  ['Shimla', 'India'],
  ['Darjeeling', 'India'],
  ['Bangkok', 'Thailand'],
  ['Chiang Mai', 'Thailand'],
  ['Chiang Rai', 'Thailand'],
  ['Ayutthaya', 'Thailand'],
  ['Phuket Town', 'Thailand'],
  ['Krabi', 'Thailand'],
  ['Pattaya', 'Thailand'],
  ['Hanoi', 'Vietnam'],
  ['Ho Chi Minh City', 'Vietnam'],
  ['Hue', 'Vietnam'],
  ['Hoi An', 'Vietnam'],
  ['Da Nang', 'Vietnam'],
  ['Nha Trang', 'Vietnam'],
  ['Da Lat', 'Vietnam'],
  ['Phnom Penh', 'Cambodia'],
  ['Siem Reap', 'Cambodia'],
  ['Battambang', 'Cambodia'],
  ['Vientiane', 'Laos'],
  ['Luang Prabang', 'Laos'],
  ['Pakse', 'Laos'],
  ['Yangon', 'Myanmar'],
  ['Mandalay', 'Myanmar'],
  ['Bagan', 'Myanmar'],
  ['Naypyidaw', 'Myanmar'],
  ['Kuala Lumpur', 'Malaysia'],
  ['George Town', 'Malaysia'],
  ['Malacca', 'Malaysia'],
  ['Kota Kinabalu', 'Malaysia'],
  ['Singapore', 'Singapore'],
  ['Jakarta', 'Indonesia'],
  ['Yogyakarta', 'Indonesia'],
  ['Ubud', 'Indonesia'],
  ['Denpasar', 'Indonesia'],
  ['Surabaya', 'Indonesia'],
  ['Bandung', 'Indonesia'],
  ['Kathmandu', 'Nepal'],
  ['Pokhara', 'Nepal'],
  ['Bhaktapur', 'Nepal'],
  ['Colombo', 'Sri Lanka'],
  ['Kandy', 'Sri Lanka'],
  ['Galle', 'Sri Lanka'],
  ['Thimphu', 'Bhutan'],
  ['Dhaka', 'Bangladesh'],
  ['Almaty', 'Kazakhstan'],
  ['Astana', 'Kazakhstan'],
  ['Samarkand', 'Uzbekistan'],
  ['Bukhara', 'Uzbekistan'],
  ['Tashkent', 'Uzbekistan'],
  ['Bishkek', 'Kyrgyzstan'],
  ['Ulaanbaatar', 'Mongolia'],
  ['Manila', 'Philippines'],
  ['Cebu City', 'Philippines'],
  ['Vigan', 'Philippines'],
  ['Baguio', 'Philippines'],
  ['Iloilo City', 'Philippines'],
  ['Davao', 'Philippines'],
  ['Puerto Princesa', 'Philippines']
] as const

const MIDDLE_EASTERN_CITIES = [
  ['Istanbul', 'Turkey'],
  ['Goreme', 'Turkey'],
  ['Ankara', 'Turkey'],
  ['Izmir', 'Turkey'],
  ['Ephesus', 'Turkey'],
  ['Jerusalem', 'Israel and the Palestinian Territories'],
  ['Tel Aviv', 'Israel'],
  ['Haifa', 'Israel'],
  ['Amman', 'Jordan'],
  ['Petra', 'Jordan'],
  ['Aqaba', 'Jordan'],
  ['Beirut', 'Lebanon'],
  ['Byblos', 'Lebanon'],
  ['Muscat', 'Oman'],
  ['Nizwa', 'Oman'],
  ['Dubai', 'United Arab Emirates'],
  ['Abu Dhabi', 'United Arab Emirates'],
  ['Doha', 'Qatar'],
  ['Manama', 'Bahrain'],
  ['Jeddah', 'Saudi Arabia']
] as const

const AFRICAN_CITIES = [
  ['Marrakech', 'Morocco'],
  ['Fes', 'Morocco'],
  ['Casablanca', 'Morocco'],
  ['Rabat', 'Morocco'],
  ['Chefchaouen', 'Morocco'],
  ['Essaouira', 'Morocco'],
  ['Meknes', 'Morocco'],
  ['Tangier', 'Morocco'],
  ['Ouarzazate', 'Morocco'],
  ['Tetouan', 'Morocco'],
  ['Cairo', 'Egypt'],
  ['Alexandria', 'Egypt'],
  ['Luxor', 'Egypt'],
  ['Aswan', 'Egypt'],
  ['Giza', 'Egypt'],
  ['Hurghada', 'Egypt'],
  ['Sharm El Sheikh', 'Egypt'],
  ['Port Said', 'Egypt'],
  ['Cape Town', 'South Africa'],
  ['Johannesburg', 'South Africa'],
  ['Durban', 'South Africa'],
  ['Pretoria', 'South Africa'],
  ['Stellenbosch', 'South Africa'],
  ['Franschhoek', 'South Africa'],
  ['Gqeberha', 'South Africa'],
  ['Bloemfontein', 'South Africa'],
  ['Knysna', 'South Africa'],
  ['Hermanus', 'South Africa'],
  ['Nairobi', 'Kenya'],
  ['Mombasa', 'Kenya'],
  ['Lamu', 'Kenya'],
  ['Kampala', 'Uganda'],
  ['Entebbe', 'Uganda'],
  ['Kigali', 'Rwanda'],
  ['Addis Ababa', 'Ethiopia'],
  ['Lalibela', 'Ethiopia'],
  ['Gondar', 'Ethiopia'],
  ['Dar es Salaam', 'Tanzania'],
  ['Zanzibar City', 'Tanzania'],
  ['Arusha', 'Tanzania'],
  ['Accra', 'Ghana'],
  ['Kumasi', 'Ghana'],
  ['Dakar', 'Senegal'],
  ['Saint-Louis', 'Senegal'],
  ['Lagos', 'Nigeria'],
  ['Abuja', 'Nigeria'],
  ['Benin City', 'Nigeria'],
  ['Cape Coast', 'Ghana'],
  ['Abidjan', "Cote d'Ivoire"],
  ['Yamoussoukro', "Cote d'Ivoire"],
  ['Freetown', 'Sierra Leone'],
  ['Monrovia', 'Liberia'],
  ['Windhoek', 'Namibia'],
  ['Swakopmund', 'Namibia'],
  ['Luderitz', 'Namibia'],
  ['Gaborone', 'Botswana'],
  ['Maun', 'Botswana'],
  ['Livingstone', 'Zambia'],
  ['Lusaka', 'Zambia'],
  ['Harare', 'Zimbabwe'],
  ['Bulawayo', 'Zimbabwe'],
  ['Maputo', 'Mozambique'],
  ['Antananarivo', 'Madagascar'],
  ['Nosy Be', 'Madagascar'],
  ['Port Louis', 'Mauritius'],
  ['Victoria', 'Seychelles'],
  ['Saint-Denis', 'Reunion'],
  ['Moroni', 'Comoros'],
  ['Praia', 'Cabo Verde'],
  ['Mindelo', 'Cabo Verde'],
  ['Tunis', 'Tunisia'],
  ['Sidi Bou Said', 'Tunisia'],
  ['Kairouan', 'Tunisia'],
  ['Algiers', 'Algeria'],
  ['Oran', 'Algeria'],
  ['Constantine', 'Algeria'],
  ['Tripoli', 'Libya'],
  ['Ghardaia', 'Algeria'],
  ['Bamako', 'Mali'],
  ['Ouagadougou', 'Burkina Faso']
] as const

const NORTH_AMERICAN_CITIES = [
  ['New York City', 'United States'],
  ['Boston', 'United States'],
  ['Philadelphia', 'United States'],
  ['Washington, D.C.', 'United States'],
  ['Baltimore', 'United States'],
  ['Charleston', 'United States'],
  ['Savannah', 'United States'],
  ['Miami', 'United States'],
  ['Orlando', 'United States'],
  ['New Orleans', 'United States'],
  ['Nashville', 'United States'],
  ['Memphis', 'United States'],
  ['Atlanta', 'United States'],
  ['Chicago', 'United States'],
  ['Detroit', 'United States'],
  ['Cleveland', 'United States'],
  ['Pittsburgh', 'United States'],
  ['St. Louis', 'United States'],
  ['Kansas City', 'United States'],
  ['Minneapolis', 'United States'],
  ['Denver', 'United States'],
  ['Santa Fe', 'United States'],
  ['Phoenix', 'United States'],
  ['Las Vegas', 'United States'],
  ['Salt Lake City', 'United States'],
  ['Seattle', 'United States'],
  ['Portland', 'United States'],
  ['San Francisco', 'United States'],
  ['Los Angeles', 'United States'],
  ['San Diego', 'United States'],
  ['Honolulu', 'United States'],
  ['Anchorage', 'United States'],
  ['Austin', 'United States'],
  ['San Antonio', 'United States'],
  ['Dallas', 'United States'],
  ['Toronto', 'Canada'],
  ['Montreal', 'Canada'],
  ['Quebec City', 'Canada'],
  ['Ottawa', 'Canada'],
  ['Vancouver', 'Canada'],
  ['Victoria', 'Canada'],
  ['Calgary', 'Canada'],
  ['Edmonton', 'Canada'],
  ['Halifax', 'Canada'],
  ["St. John's", 'Canada'],
  ['Winnipeg', 'Canada'],
  ['Saskatoon', 'Canada'],
  ['Banff', 'Canada'],
  ['Whitehorse', 'Canada'],
  ['Yellowknife', 'Canada'],
  ['Mexico City', 'Mexico'],
  ['Oaxaca', 'Mexico'],
  ['Puebla', 'Mexico'],
  ['Guadalajara', 'Mexico'],
  ['Guanajuato', 'Mexico'],
  ['San Miguel de Allende', 'Mexico'],
  ['Merida', 'Mexico'],
  ['Cancun', 'Mexico'],
  ['Playa del Carmen', 'Mexico'],
  ['Tulum', 'Mexico'],
  ['Campeche', 'Mexico'],
  ['Morelia', 'Mexico'],
  ['Monterrey', 'Mexico'],
  ['Queretaro', 'Mexico'],
  ['San Cristobal de las Casas', 'Mexico'],
  ['Guatemala City', 'Guatemala'],
  ['Antigua Guatemala', 'Guatemala'],
  ['Belize City', 'Belize'],
  ['San Ignacio', 'Belize'],
  ['San Salvador', 'El Salvador'],
  ['Suchitoto', 'El Salvador'],
  ['Tegucigalpa', 'Honduras'],
  ['Granada', 'Nicaragua'],
  ['Leon', 'Nicaragua'],
  ['Panama City', 'Panama'],
  ['Havana', 'Cuba'],
  ['San Juan', 'Puerto Rico'],
  ['Santo Domingo', 'Dominican Republic'],
  ['Nassau', 'Bahamas'],
  ['Willemstad', 'Curacao']
] as const

const SOUTH_AMERICAN_CITIES = [
  ['Rio de Janeiro', 'Brazil'],
  ['Sao Paulo', 'Brazil'],
  ['Salvador', 'Brazil'],
  ['Brasilia', 'Brazil'],
  ['Recife', 'Brazil'],
  ['Olinda', 'Brazil'],
  ['Fortaleza', 'Brazil'],
  ['Manaus', 'Brazil'],
  ['Belem', 'Brazil'],
  ['Curitiba', 'Brazil'],
  ['Florianopolis', 'Brazil'],
  ['Porto Alegre', 'Brazil'],
  ['Ouro Preto', 'Brazil'],
  ['Paraty', 'Brazil'],
  ['Foz do Iguacu', 'Brazil'],
  ['Buenos Aires', 'Argentina'],
  ['Mendoza', 'Argentina'],
  ['Cordoba', 'Argentina'],
  ['Salta', 'Argentina'],
  ['Ushuaia', 'Argentina'],
  ['Bariloche', 'Argentina'],
  ['Rosario', 'Argentina'],
  ['El Calafate', 'Argentina'],
  ['Cafayate', 'Argentina'],
  ['Mar del Plata', 'Argentina'],
  ['Santiago', 'Chile'],
  ['Valparaiso', 'Chile'],
  ['Vina del Mar', 'Chile'],
  ['San Pedro de Atacama', 'Chile'],
  ['Puerto Varas', 'Chile'],
  ['Punta Arenas', 'Chile'],
  ['Castro', 'Chile'],
  ['La Serena', 'Chile'],
  ['Lima', 'Peru'],
  ['Cusco', 'Peru'],
  ['Arequipa', 'Peru'],
  ['Puno', 'Peru'],
  ['Trujillo', 'Peru'],
  ['Iquitos', 'Peru'],
  ['Huaraz', 'Peru'],
  ['Ayacucho', 'Peru'],
  ['Chiclayo', 'Peru'],
  ['Puerto Maldonado', 'Peru'],
  ['Bogota', 'Colombia'],
  ['Cartagena', 'Colombia'],
  ['Medellin', 'Colombia'],
  ['Cali', 'Colombia'],
  ['Santa Marta', 'Colombia'],
  ['Barranquilla', 'Colombia'],
  ['Villa de Leyva', 'Colombia'],
  ['Salento', 'Colombia'],
  ['Popayan', 'Colombia'],
  ['San Andres', 'Colombia'],
  ['Quito', 'Ecuador'],
  ['Cuenca', 'Ecuador'],
  ['Guayaquil', 'Ecuador'],
  ['Loja', 'Ecuador'],
  ['Banos', 'Ecuador'],
  ['Otavalo', 'Ecuador'],
  ['Puerto Ayora', 'Ecuador'],
  ['La Paz', 'Bolivia'],
  ['Sucre', 'Bolivia'],
  ['Potosi', 'Bolivia'],
  ['Montevideo', 'Uruguay'],
  ['Colonia del Sacramento', 'Uruguay'],
  ['Punta del Este', 'Uruguay'],
  ['Asuncion', 'Paraguay'],
  ['Georgetown', 'Guyana'],
  ['Paramaribo', 'Suriname'],
  ['Cayenne', 'French Guiana']
] as const

const OCEANIAN_CITIES = [
  ['Sydney', 'Australia'],
  ['Melbourne', 'Australia'],
  ['Brisbane', 'Australia'],
  ['Perth', 'Australia'],
  ['Adelaide', 'Australia'],
  ['Canberra', 'Australia'],
  ['Hobart', 'Australia'],
  ['Darwin', 'Australia'],
  ['Cairns', 'Australia'],
  ['Gold Coast', 'Australia'],
  ['Newcastle', 'Australia'],
  ['Fremantle', 'Australia'],
  ['Broome', 'Australia'],
  ['Alice Springs', 'Australia'],
  ['Launceston', 'Australia'],
  ['Auckland', 'New Zealand'],
  ['Wellington', 'New Zealand'],
  ['Christchurch', 'New Zealand'],
  ['Queenstown', 'New Zealand'],
  ['Dunedin', 'New Zealand'],
  ['Rotorua', 'New Zealand'],
  ['Napier', 'New Zealand'],
  ['Nelson', 'New Zealand'],
  ['Tauranga', 'New Zealand'],
  ['Hamilton', 'New Zealand'],
  ['Suva', 'Fiji'],
  ['Nadi', 'Fiji'],
  ['Apia', 'Samoa'],
  ["Nuku'alofa", 'Tonga'],
  ['Port Vila', 'Vanuatu']
] as const

const CITY_DESTINATIONS = [
  ...EUROPEAN_CITIES,
  ...ASIAN_CITIES,
  ...MIDDLE_EASTERN_CITIES,
  ...AFRICAN_CITIES,
  ...NORTH_AMERICAN_CITIES,
  ...SOUTH_AMERICAN_CITIES,
  ...OCEANIAN_CITIES
]

export const MUST_VISIT_CITIES_ITEMS: ThemeItem[] = CITY_DESTINATIONS.map(([city, country]) => ({
  name: `${city}, ${country}`,
  imageUrl: null,
  fact: `${city} is featured for its cultural, historical, or travel significance in ${country}.`,
  sourceId: 'wikivoyage-search',
  sourcePath: `${city}, ${country}`
}))
